var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
    'button',
    ("button--" + _vm.variant),
    {
      'button--disabled': _vm.disabled,
      'button--rounded': _vm.rounded,
      'button--focused': _vm.focused
    }
  ],on:{"touchstart":function($event){_vm.focused = true},"touchend":function($event){_vm.focused = false},"mousedown":function($event){_vm.focused = true},"mouseup":function($event){_vm.focused = false}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }